import { render } from "./ToggleIcon.vue?vue&type=template&id=65b29044"
import script from "./ToggleIcon.vue?vue&type=script&lang=js"
export * from "./ToggleIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__